/* eslint-disable no-console */
export default () => ({
  methods: {
    getErrorMessage(err, fallback = "status.error") {
      try {
        const msgKey = "error." + (err && err.response && err.response.data && err.response.data.message) || (err && err.message);
        const msgText = this.$t(msgKey);
        if (msgText != msgKey) {
          return msgText;
        }
        return this.$t(fallback);
      } catch (error) {
        console.error({error});
        return this.$t(fallback);
      }
    }
  }
});
